<script setup>
import ListItem from '@/components/Service/ListItem'
import ListSelectItem from '@/components/Service/ListSelectItem'

defineProps({
  services: {
    type: Array,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  locked: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['productAdd', 'productRemove'])

const productAdd = (data) => {
  emits('productAdd', data)
}

const productRemove = (data) => {
  emits('productRemove', data)
}
</script>

<template>
  <div class="grid grid-cols-1 gap-x-14 lg:grid-cols-2">
    <template
      v-for="service in services"
      :key="service.id"
    >
      <ListSelectItem
        :id="service.id"
        :name="service.name"
        :description="service.description"
        :currency="service.currency"
        :selectedAmount="service.selected_amount"
        :items="service.items"
        :selected="service.selected"
        :selectedItemId="service.selected_item_id"
        :image="service.image_path"
        :locked="locked"
        :disabled="disabled"
        :allowAmount="true"
        @productAdd="productAdd"
        @productRemove="productRemove"
        v-if="service.items.length"
      />

      <ListItem
        :id="service.id"
        :name="service.name"
        :description="service.description"
        :price="service.price"
        :currency="service.currency"
        :minAmount="service.min_amount"
        :maxAmount="service.max_amount"
        :selectedAmount="service.selected_amount"
        :selected="service.selected"
        :image="service.image_path"
        :locked="locked"
        :disabled="disabled"
        :allowAmount="true"
        @productAdd="productAdd"
        @productRemove="productRemove"
        v-else
      />
    </template>
  </div>
</template>